<template>
    <v-container>

        <button-cadu name="btnTeste" @click="teste" text="teste" :outline="true" backColor="#00995D" :disabled="false"/>
        <button-cadu :outline="false" backColor="#B1D34B" :disabled="false"/>
        <button-cadu backColor="#B1D34B" :disabled="false"/>
        <button-cadu backColor="#F47920" :disabled="false"/>
        <button-cadu backColor="#FFCB08" :disabled="false"/>
        <button-cadu backColor="#B1D34B" :outline="true" :disabled="true"/>
        <autocompletecheck-cadu
          title="AutoComplete"
          v-model="selected"
          @checkBoxValue="value => checkBoxValue = value"
          :itemsValueCheckBox="secondItems.map((el) => el.valor)"
          :items="secondItems.map((el) => el.nome)"
          :checkBoxList="true"
        />
        <checkList-cadu :listaFiltro="secondItems"/>
        <br/>
        <v-row>
            <v-col cols="4">
              <ValidationProvider name="teste" rules="required" v-slot:default="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Nome do Campo"
                  v-model="value"
                  name="nomeCampo"
                />
              </ValidationProvider>
                <input-cadu
                  title="Nome do Campo"
                  icon="calendar"
                  :sizeIcon="15"
                  v-model="value"
                />
                <ValidationProvider name="teste" rules="required" v-slot:default="{ errors }">
                  <Autocomplete
                    :errorMessage="errors[0]"
                    title="AutoComplete"
                    v-model="selected"
                    :items="items"
                  />
                </ValidationProvider>
            </v-col>
            <v-col cols="4">
                {{value}}
            </v-col>
        </v-row>
        <v-row>
          <switch-cadu v-model="value3" :disable="true" color="red"/>
          <switch-cadu v-model="value4" color="green"/>
          <switch-cadu v-model="value5" color="blue"/>
          <!-- <v-col>
            <switch-cadu color="red"/>
            <switch-cadu color="green"/>
            <switch-cadu color="blue"/>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col>
            <checkbox-cadu v-model="valueCheck" value="1" color="#00995D">
              testando
            </checkbox-cadu>
            <checkbox-cadu v-model="valueCheck" value="2" color="#00995D">
              testando
            </checkbox-cadu>
            <checkbox-cadu v-model="valueCheck" value="3" color="#00995D">
              testando
            </checkbox-cadu>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Autocomplete from '../components/Shared/AutoComplete/AutoComplete'
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    Autocomplete,
    ValidationProvider
  },
  data () {
    return {
      value: '',
      value3: 0,
      value4: 0,
      value5: 0,
      valueCheck: [],
      checkBoxValue: [],
      selected: '',
      switch: 0,
      items: [
        'Apple', 'Banana', 'Orange', 'Mango', 'Pear', 'Peach', 'Grape', 'Tangerine', 'Pineapple'
      ],

      secondItems: [
        {
          valor: 'CONFIRMADO',
          nome: 'Confirmado'
        },
        {
          valor: 'PENDENTE',
          nome: 'Pendente'
        }
      ]
    }
  },
  methods: {
    teste () {
    }
  }
}
</script>
